import { UserError } from './user/user-error';

export class StakeError extends UserError {}
